import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {AgeLabelComponent} from './age-label.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
    ],
    declarations: [
        AgeLabelComponent,
    ],
    exports: [
        AgeLabelComponent
    ],
})
export class AgeLabelModule{}
